// extracted by mini-css-extract-plugin
export default {"contentOpen":"StatusDropdownContent_contentOpen__fbD9i","contentClosed":"StatusDropdownContent_contentClosed__rtpde"};